import { render, staticRenderFns } from "./MinimalLayout.vue?vue&type=template&id=ee3f9c6e&scoped=true&"
import script from "./MinimalLayout.vue?vue&type=script&lang=js&"
export * from "./MinimalLayout.vue?vue&type=script&lang=js&"
import style0 from "./MinimalLayout.vue?vue&type=style&index=0&id=ee3f9c6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee3f9c6e",
  null
  
)

export default component.exports